<template>
  <div>
    <Card>
      <Row>
        <Button type="info"
                @click="add">{{$t('pages_banners_index_178')}}</Button>
      </Row>
      <TablePaginate :columns="columns"
                     :data="score_products"
                     :loading="loading"
                     :meta="meta"
                     :changePage="changePage"></TablePaginate>
    </Card>
    <Modal v-model="modalShow"
           @on-ok="handleSubmit"
           :title="$t('pages_score_products_index_926')">
      <Form ref="score_product"
            :model="score_product"
            :label-width="80">
        <Form-item :label="$t('pages_orders_index_636')"
                   prop="name">
          <Input type="text"
                 v-model="score_product.name" />
        </Form-item>
        <Form-item :label="$t('pages_combo_index_282')"
                   prop="price">
          <Input type="number"
                 v-model="score_product.price" />
        </Form-item>
        <Form-item :label="$t('pages_customers_index_338')"
                   prop="score">
          <Input type="number"
                 v-model="score_product.score" />
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapState, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { deleteButtonInTable, editorButtonInTable } from '@/libs/table-render'

export default {
  components: {
    TablePaginate,
  },
  data () {
    return {
      modalShow: false,
      formType: '',
      columns: [
        {
          title: i18n.t('pages_bookings_detail_222'),
          key: 'name'
        },
        {
          title: i18n.t('pages_customers_index_338'),
          key: 'score',
        },
        {
          title: i18n.t('pages_combo_index_282'),
          key: 'price',
        },
        {
          title: i18n.t('pages_balance_transaction_index_177'),
          key: 'created_at_str',
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 200,
          align: 'center',
          render: (h, params) => {
            const children = []
            children.push(deleteButtonInTable(this, h, params))
            children.push(editorButtonInTable(this, h, params))
            return h('div', children)
          }
        }
      ]
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index()
  },
  computed: {
    ...mapState('score_product', ['score_product', 'score_products', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('score_product', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),
    ...mapMutations('score_product', ['changeQuery']),
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    uploadedUrl (url) {
      this.score_product.image = url
    },
    async handleSubmit () {
      if (this.formType === 'edit') {
        await this.update(this.score_product)
      } else if (this.formType === 'new') {
        await this.create(this.score_product)
      }
      this.modalShow = false
    }
  }
}
</script>
